// extracted by mini-css-extract-plugin
export var dark = "t_sz";
export var darkcookie = "t_sB";
export var tintedcookie = "t_sC";
export var regularcookie = "t_sD";
export var darkbase = "t_sF";
export var tintedbase = "t_sG";
export var regularbase = "t_sH";
export var darkraw = "t_sJ";
export var tintedraw = "t_sK";
export var regularraw = "t_sL";
export var darkchick = "t_sM";
export var tintedchick = "t_sN";
export var regularchick = "t_sP";
export var darkherbarium = "t_sQ";
export var tintedherbarium = "t_sR";
export var regularherbarium = "t_sS";
export var darkholiday = "t_sT";
export var tintedholiday = "t_sV";
export var regularholiday = "t_sW";
export var darkoffline = "t_sX";
export var tintedoffline = "t_sY";
export var regularoffline = "t_sZ";
export var darkorchid = "t_s0";
export var tintedorchid = "t_s1";
export var regularorchid = "t_s2";
export var darkpro = "t_s3";
export var tintedpro = "t_s4";
export var regularpro = "t_s5";
export var darkrose = "t_s6";
export var tintedrose = "t_s7";
export var regularrose = "t_s8";
export var darktimes = "t_s9";
export var tintedtimes = "t_tb";
export var regulartimes = "t_tc";
export var darkwagon = "t_td";
export var tintedwagon = "t_tf";
export var regularwagon = "t_tg";